import React, { Component } from 'react'

export default class WorksUltimaSera extends Component {
    render() {
        return (

            <div class="modal" id="worksultimasera" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;Ultima sera dell'anno&quot;</strong>(racconti):<em> &nbsp;&nbsp;Il lavoro editoriale,Ancona, 1988,&nbsp;  </em></h5>
                          
                        </div>
                        <div class="modal-body p-4" id="result">
                            <div align="left">
                                <br />
                                <strong>ne hanno scritto:</strong> <br /><br />

                                Attilio Lolini, l'Unità, 16.11.88<br />
                                Generoso Picone, Il Mattino di Napoli, 3.1.89<br />
                                Vittorio Coletti, L'Adige, 9.6.88<br />
                                Carlo Martinelli, L'Alto Adige, 29.4.88<br />
                                Pier Vittorio Tondelli, Rock Star, giugno 88<br />
                                Fulvio Panzeri, La Gazzetta di Como, 14.4.88
Giampaolo Visetti, L'Adige, 9.6.88<br />
                                Gino Gerola, QuestoTrentino, giugno 88<br />
                                Luigi Serravalli, UCT, marzo 89<br />


                            </div>
                        </div>
                        <div align="left">

                            <strong> Selezione Stampa</strong>
                            <table border="0" align="center" cellspacing="7">
                                <tr>
                                    <td align="center" width="100">Il Mattino di Napoli,
                                     3/1/1989: "Soggetti Smarriti" di Generoso
        Picone.(264k)</td>
                                    <td><a href="rec\ultima sera-soggetti smarriti.zip"><img
                                        src="./img/rec/ultima%20sera-soggetti%20smarriti_small.jpg"
                                        alt="scarica in formato zip"
                                        width="151" height="280" /></a>
                                    </td>
                                </tr> <tr>
                                    <td align="center" width="100">l'Adige, 9/6/1988:
                                    "Otto Racconti di Tamburini" di Vittorio
        Coletti.(181k)</td> <td><a href="rec\ultimasera-otto.zip"><img
                                        src="./img/rec/ultimasera-otto%20racconti%20_small.jpg"
                                        alt="scarica in formato zip"
                                        width="156"
                                        height="258" /></a>
                                    </td>
                                </tr> <tr>
                                    <td align="center" width="100">"Imparare la Vita
        Alla Fine" di Attilio Lolini.(152k)
            </td> <td><a href="rec\ultimasera-imparare alla fine della vita.zip"><img
                                        src="./img/rec/ultimasera-imparare%20alla%20fine%20della%20vita_small.gif" alt="scarica in formato zip"

                                        align="middle" width="104" height="330" /></a>
                                    </td>

                                </tr>

                            </table>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                        </div>
                    </div>
                </div>
            </div >


        )
    }
}
